import React from "react";
import "../../assets/css/home.css";
import { useNavigate, useParams } from "react-router-dom";
import { Button, styled } from "@mui/material";
import { ChevronLeft } from "@mui/icons-material";

const ColorButton = styled((props) => <Button variant="outlined" {...props} />)(
  {
    color: "rgb(0,105,255)",
    borderRadius: "30px",
    height: "50px",
  }
);

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const IntegrationHeader = (props) => {
  const { integration } = useParams();
  const { navigate } = useNavigate();

  return (
    <div style={{ position: 'relative' }}>
      <div className="content-header" style={{ height: "100px" }}>
        <div className="content-head" style={{ justifyContent: "center" }}>
          <div className="flex align">
            <div className="flex">
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  alignItems: "center",
                  width: "100%",
                  flex: 1,
                }}
              >
                <ColorButton
                  href={
                    integration ? "/biz/integrations" : "/biz/bookingtypes"
                  }
                  startIcon={<ChevronLeft />}
                >
                  Back
                </ColorButton>
              </div>
            </div>
            <h2
              style={{ flex: integration && 4.5 }}
              className={"input-label justify flex"}
            >
              {integration
                ? capitalizeFirstLetter(integration) + " Information"
                : "Integrations"}
            </h2>
            <div className="flex"></div>
          </div>
        </div>
      </div>
      <props.display
        logout={props.logout ? props.logout : ""}
        data={props.data}
      />
      <div style={{
        position: 'absolute',
        top: 100,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(128, 128, 128, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        height: '81vh'
      }}>
        <h2 style={{ color: 'white', textAlign: 'center' }}>This page is a work in progress/beta</h2>
      </div>
    </div>
  );
};

export default IntegrationHeader;